import React, { Component } from "react";
import { Section, Header } from "../components/ui";

// Desing
import logo from "../assets/img/logo.svg";
import concept from "../assets/img/parking-concept-new.png";

class Services extends Component {
  render() {
    const slogan =
      "Góð geymsla fyrir bílinn meðan þú ferðast. Njóttu einfaldar og fljótlegrar þjónustu Lagningar";
    return (
      <div>
        <Header
          title={"Tryggðu þér stæði"}
          subtitle={slogan}
          concept={concept}
          logo={logo}
        />
        <Section title={"Þjónustuferlið"}>
          <ol>
            <li>
              Þú tryggir bílnum stæði hjá Lagningu yfir þann tíma sem áætlað er
              að ferðalagið taki.
            </li>
            <li>
              Láttu okkur vita í símtali með 20 mínútna fyrirvara, hvenær þú
              áætlar að vera fyrir framan flugstöðina. Við hittum þig við
              inngang Leifsstöðvar, þar sem farþegum er skutlað í flug. Þar með
              er þínu hlutverki lokið uns þú kemur aftur. Engin leit af stæðum,
              engin þörf á að leggja stæðanúmer á minnið, ekkert vesen.
            </li>
            <li>
              Við tökum við bílnum og keyrum hann á stæðið okkar þar sem hann
              bíður öruggur uns þú lendir aftur í Leifsstöð.{" "}
            </li>
            <li>
              Við bíðum þín fyrir framan brottfarir, réttum þér bíllyklana og
              bíllinn þinn bíður þín svo ylvolgur á stæði brottfararmegin.{" "}
            </li>
          </ol>
          <p>
            Grunngjaldið fyrir þjónustu Lagningar er 5.900 kr. og eftir það er
            geymslugjald fyrir hvern sólarhring 590 kr. Að auki er enginn
            hámarks- eða lágmarkstími. Við sjáum til þess að bifreiðin þín sé
            örugg mánuðum og jafnvel árum saman.{" "}
          </p>
          <p>
            Hægt er að bæta ýmiss konar aukaþjónustu við geymsluþjónustuna eins
            og þrifi, bóni, áfyllingu á eldsneyti og rúðuvökva og fleira á
            sanngjörnu verði. Því hvað er betra en að koma í ylvolgan, nýþrifinn
            og bónaðan bílinn eftir langt og strangt ferðalag?{" "}
          </p>
        </Section>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/views/Services.js